/* global $R */

import map from 'lodash/map';

$R.add('plugin', 'rellinks', {
  init(app) {
    this.app = app;
    this.options = app.opts.rellinks;
    this.component = app.component;
  },

  onmodal: {
    link: {
      /**
       * Called when the link modal is opened
       * @param {Object} $modal
       * @param {Object} $form
       * @return {void}
       */
      open($modal, $form) {
        if (!this.options) return;

        // Remove the option we could've set on previous link editing
        this.app.opts.rellinks_nofollow = '';

        this.$modal = $modal;
        this.$form = $form;

        // If we're editing this will return the link element
        this.$link = this.getCurrentLink();

        // If we're editing and thus $link is an element we preselect the correct rel option
        if (typeof this.$link !== 'undefined') {
          this.app.opts.rellinks_nofollow = this.$link.getAttribute('rel');
        }

        // Create select box etc.
        this.build();
      },
    },
  },

  /**
   * Get the currently selected link
   * @return {Object}
   */
  getCurrentLink() {
    return this.app.selection.getInlinesAllSelected({ tags: ['a'] })[0];
  },

  onlink: {
    inserted(link) {
      this.updateRel(link);
    },

    updated(link) {
      this.updateRel(link);
    },
  },

  /**
   * Update rel attribute on link
   * @param {Object} link
   * @return {void}
   */
  updateRel(link) {
    const { app } = link;
    const { opts } = app;
    const nofollow = typeof opts.rellinks_nofollow !== 'undefined' ? opts.rellinks_nofollow : '';

    if (nofollow) {
      this.app.api('module.inline.add', {
        attr: {
          rel: nofollow,
        },
      });
    } else {
      this.app.api('module.inline.remove', {
        attr: 'rel',
      });
    }
  },

  /**
   * Build the select in the modal
   * @return {void}
   */
  build() {
    let $selector = this.$modal.find('#redactor-rel-links');

    // If there's no selector, we create it
    if ($selector.length === 0) {
      const $body = this.$modal.getBody();
      const $item = $R.dom('<div class="form-item" />');
      const $label = $R.dom('<label for="redactor-rel-links">Rel</label>');
      $selector = $R.dom('<select id="redactor-rel-links" />');

      $item.append($label);
      $item.append($selector);
      $body.find('form').append($item);
    }

    // Remove options
    $selector.html('');

    // Remove old event listeners
    $selector.off('change');

    // Loop through possible options
    map(this.options, (item) => {
      const $option = $R.dom('<option>');
      $option.val(item);
      $option.html(`${item}`);

      if (this.app.opts.rellinks_nofollow === item) {
        $option.attr('selected', 'selected');
      }

      $selector.append($option);
    });

    $selector.on('change', this.select.bind(this));
  },

  /**
   * Handle selection of the rel option
   * @param {Object} e
   * @return {void}
   */
  select(e) {
    const val = $R.dom(e.target).val();

    // We can't pass the rel attribute directly to the link (unfortunately). So
    // we temporarily store it in the global plugin options
    this.app.opts.rellinks_nofollow = val;
  },
});
